/* Hover intent enhances native details; clicks, keyboard and touch remain native. */
(() => {
 const fine=matchMedia('(hover: hover) and (pointer: fine)'),mounted=new WeakSet(),controllers=new Map();
 const selector='.header__inline-menu header-menu > details, [data-gx-hover-menu]';
 const primary=d=>!!d.closest('.header__inline-menu');
 const enabled=e=>fine.matches&&innerWidth>=990&&e?.pointerType!=='touch'&&e?.pointerType!=='pen';
 function set(details,open){details.open=open;details.querySelector(':scope > summary')?.setAttribute('aria-expanded',String(open));}
 function clearPending(){for(const c of controllers.values())c.cancelOpen();}
 function peers(details){document.querySelectorAll(selector).forEach(other=>{if(other!==details){controllers.get(other)?.cancelAll();set(other,false);}});}
 function mount(root=document){
  root.querySelectorAll(selector).forEach(details=>{
   if(mounted.has(details))return;mounted.add(details);
   const summary=details.querySelector(':scope > summary');if(!summary)return;
   let openTimer,closeTimer,openedByHover=false;
   const cancelOpen=()=>{clearTimeout(openTimer);openTimer=null;};
   const cancelAll=()=>{cancelOpen();clearTimeout(closeTimer);};
   controllers.set(details,{cancelOpen,cancelAll});
   details.addEventListener('pointerenter',event=>{
    if(!enabled(event))return;clearTimeout(closeTimer);
    if(details.open)return;
    // A primary menu owns the pointer journey to its panel; departments cannot steal it.
    if(!primary(details)&&[...document.querySelectorAll('.header__inline-menu header-menu > details[open]')].length)return;
    clearPending();
    openTimer=setTimeout(()=>{
     if(!details.isConnected||!details.matches(':hover')||!enabled(event))return;
     if(!primary(details)&&document.querySelector('.header__inline-menu header-menu > details[open]'))return;
     openedByHover=true;peers(details);set(details,true);
    },170);
   });
   details.addEventListener('pointerleave',()=>{
    cancelOpen();if(!fine.matches||innerWidth<990)return;
    closeTimer=setTimeout(()=>{if(!details.contains(document.activeElement))set(details,false);},350);
   });
   // Cancel pending hover before the browser performs the summary's normal toggle.
   summary.addEventListener('pointerdown',clearPending,{passive:true});
   summary.addEventListener('click',event=>{
    cancelOpen();
    // A first pointer click pins an already hover-open menu instead of unexpectedly closing it.
    if(event.detail>0&&details.open&&openedByHover){event.preventDefault();openedByHover=false;return;}
    openedByHover=false;
   });
   details.addEventListener('focusout',()=>{setTimeout(()=>{if(!details.contains(document.activeElement)&&!details.matches(':hover'))set(details,false);},0);});
   details.addEventListener('toggle',()=>{summary.setAttribute('aria-expanded',String(details.open));if(details.open){cancelOpen();peers(details);}else openedByHover=false;});
   details.addEventListener('keydown',event=>{if(event.key==='Escape'){cancelAll();set(details,false);summary.focus();event.stopPropagation();}});
  });
  measure();
 }
 function measure(){
  document.querySelectorAll('.header-wrapper').forEach(wrapper=>{
   const header=wrapper.querySelector('header.header');if(!header)return;
   wrapper.style.setProperty('--gx-primary-menu-top',Math.max(0,header.getBoundingClientRect().bottom-wrapper.getBoundingClientRect().top)+'px');
  });
 }
 mount();
 if(typeof ResizeObserver!=='undefined'){const observer=new ResizeObserver(measure);document.querySelectorAll('header.header').forEach(header=>observer.observe(header));}
 window.addEventListener('resize',measure,{passive:true});
 fine.addEventListener('change',()=>{clearPending();measure();});
 document.addEventListener('shopify:section:load',event=>mount(event.target));
 document.addEventListener('click',event=>{document.querySelectorAll(selector).forEach(details=>{if(details.open&&!details.contains(event.target)){controllers.get(details)?.cancelAll();set(details,false);}});});
})();
